module.exports = __webpack_public_path__ + "officialStatic/img/new21.cf9ef59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news/new21.jpg
// module id = 2xLZ
// module chunks = 0